import React from 'react';
import { Link } from 'react-router-dom';

function Section({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-lg font-bold text-gray-900">{title}</h2>
      <div className="text-sm text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border p-8 space-y-6">
        <div>
          <Link to="/" className="text-sm text-purple-600 hover:underline">← Back to home</Link>
          <h1 className="mt-2 text-3xl font-bold text-gray-900">Privacy Policy</h1>
          <p className="text-xs text-gray-400 mt-1">Last updated: February 2026</p>
        </div>

        <Section title="1. Information We Collect">
          We collect bank account information via Plaid (read-only), identity verification data via Persona, and revenue
          data via Stripe Connect. We also collect basic profile information (name, email, business details) you provide
          directly. We never store your bank login credentials.
        </Section>

        <Section title="2. How We Use Information">
          Your information is used solely to underwrite credit decisions, service active loans, and operate the platform.
          We do not sell your personal information to third parties or use it for advertising.
        </Section>

        <Section title="3. Data Security">
          Data is encrypted at rest and in transit (TLS 1.2+). Access is restricted to authorized Tranchly personnel on a
          need-to-know basis. We maintain industry-standard administrative, physical, and technical safeguards.
        </Section>

        <Section title="4. Plaid Data Usage">
          Tranchly uses Plaid to securely connect your bank account. Plaid access is read-only — we cannot move funds or
          make changes to your account. Data retrieved is used exclusively for credit assessment and ongoing loan servicing.
        </Section>

        <Section title="5. Your Rights">
          You may request a copy of your personal data, correction of inaccuracies, or deletion of your account at any time.
          Email <a className="text-purple-600 hover:underline" href="mailto:hello@tranchly.finance">hello@tranchly.finance</a> to
          initiate a request. Some records may be retained as required by financial regulations.
        </Section>

        <Section title="6. Cookie Policy">
          We use essential cookies to keep you signed in and to remember your preferences. We do not use third-party
          advertising cookies.
        </Section>

        <Section title="7. Contact">
          Privacy questions? Email <a className="text-purple-600 hover:underline" href="mailto:hello@tranchly.finance">hello@tranchly.finance</a>.
        </Section>

        <p className="text-xs text-gray-400 border-t pt-4">
          Not FDIC insured. Not investment advice. Principal at risk. Tranchly is not a licensed bank.
        </p>
      </div>
    </div>
  );
}
